import $ from 'jquery'

import { SfTime } from '@app/adapters/time'

const KEY_RETURN = 13

const processDate = (datepicker, event) => {
  const format =
    datepicker.data().momentJsFormat ||
    datepicker.data().dateFormat.toUpperCase()
  const date = event.target.value

  if (!date || !date.trim()) return

  const finalDate = SfTime(date, format)

  if (!finalDate.isValid()) return
  if (finalDate.format(format) === date) return

  event.target.value = finalDate.format(format)
}

// Delegated on the persistent document and bound once at module scope, so it
// also covers inputs added later (including inside lazy turbo frames).
$(document).on('click focus', '[data-behaviour~="datepicker"]', (event) => {
  const target = event.target
  const autoclose = target.dataset.datepickerAutoclose || false
  // bootstrap-datepicker stores its instance under data('datepicker') on first
  // init; the delegated handler fires on every click/focus, so use that as the
  // sentinel to bind the change/keydown listeners only once per input rather
  // than stacking duplicates (which would run processDate N times).
  const isFirstInit = !$(target).data('datepicker')

  const dp = $(target)
    .datepicker({
      autoclose: autoclose,
      orientation: 'bottom left',
      zIndexOffset: 99983,
    })
    .datepicker('show')

  if (!isFirstInit) return

  $(target).on('change', (event) => {
    processDate(dp, event)
  })

  $(target).on('keydown', (event) => {
    if (event.which !== KEY_RETURN) return

    processDate(dp, event)
  })
})
